const languageLogic = {
  methods: {
    localizedTokens(baseToken) {
      let track = this.$store.getters['v4/track/current'] ? this.$store.getters['v4/track/current'].path : 'default'
      let audience = this.$store.getters['v4/track/current'] ? this.$store.getters['v4/track/current'].target_audience : this.$store.state.settings.default_audience
      audience = audience === 'doctor' ? 'chw' : audience
      track = track === 'all' ? 'default' : track

      return [
        `${baseToken}.${audience}.${track}`,
        `${baseToken}.default.${track}`,
        `${baseToken}.${audience}`,
        baseToken
      ]
    },
    localizedToken(baseToken, locale) {
      let tokenCheck = this.localizedTokens(baseToken)
      let localizedToken
      tokenCheck.every(token => {
        localizedToken = token
        return (this.$i18n.t(token, locale) === token)
      })

      if (localizedToken === baseToken && locale) {
        tokenCheck.every(token => {
          localizedToken = token
          return (this.$i18n.t(token) === token)
        })
      }
      return localizedToken
    },
  }
}

export default languageLogic
